
























import {
  defineComponent,
  computed,
  PropType
} from '@nuxtjs/composition-api';
import { useImage } from '@wemade-vsf/composables';
import { SfCarousel, SfImage } from '@storefront-ui/vue';

interface GalleryImage {
  image: string,
  caption: string
}

export default defineComponent({
  name: 'ImageGallery',
  props: {
    images: {
      type: Array as PropType<Array<GalleryImage>>,
      default: () => []
    }
  },
  data () {
    return {
      sliderSettings: {
        perView: 3,
        focusAt: 'center',
        slidePerPage: false,
        gap: 0,
        peek: 0,
        breakpoints: {
          1023: {
            perView: 1,
            peek: 0
          }
        }
      }
    }
  },
  components: {
    SfImage,
    SfCarousel
  },
  setup (props) {
    const { getMagentoImage } = useImage()
    const transformedImages = computed(() => {
      return props.images.map(i => {
        i.image = i.image.startsWith('/') ? i.image : '/' + i.image
        i.image = i.image.startsWith('/media') ? i.image : '/media' + i.image;
        i.image = getMagentoImage(i.image)

        return i
      })
    })
    const sliderSettings = {
        perView: 3,
        focusAt: 'center',
        gap: 0,
        peek: 0,
        breakpoints: {
          1023: {
            perView: 1,
            peek: 0
          }
        }
      };

    return {
      sliderSettings,
      transformedImages
    }
  }
})
